import { Tag, Tooltip } from "antd";
import { Loader2, CheckCircle2, XCircle, Clock, Square } from 'lucide-react';

export default function PipelineStatusTag(props: { status?: string }) {

    if (!props.status) {
        return null;
    }

    if (["QUEUED", "PENDING"].includes(props.status)) {
        return (
            <Tooltip title="Pending execution">
                <Clock size={16} />
            </Tooltip>
        );
    } else if (["RUNNING"].includes(props.status)) {
        return (
            <Loader2 size={16} style={{ animation: 'spin 1s linear infinite' }} />
        );
    } else if (["SUCCEEDED"].includes(props.status)) {
        return (
            <CheckCircle2 size={16} />
        );
    } else if (["FAILED"].includes(props.status)) {
        return (
            <XCircle size={16} style={{ color: "red" }} />
        );
    } else if (["ABORTED"].includes(props.status)) {
        return (
            <Tooltip title="The execution was canceled due to other step failure">
                <Square size={16} style={{ color: "GrayText" }} />
            </Tooltip>
        );
    }

    return (
        <div style={{
            fontSize: "10px",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            color: "#8c8c8c",
            padding: "3px 8px",
            borderRadius: "4px",
            backgroundColor: "#8c8c8c15",
            border: "1px solid #8c8c8c25",
            display: "inline-flex",
            alignItems: "center",
            gap: "4px"
        }}>
            <span style={{ fontSize: "8px" }}>○</span>
            Unknown status
        </div>
    );
};